import React, { useEffect, useRef } from "react";
import { CheckboxProps } from "../types";

export default function Checkbox(props: CheckboxProps) {
	const { indeterminate = false, ...otherProps } = props;

	const checkbox = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (checkbox.current) {
			checkbox.current.indeterminate = indeterminate;
		}
	}, [checkbox.current, indeterminate]);

	return <input {...otherProps} ref={checkbox} type="checkbox" />;
}
